import { formatTime } from '../game/progress';

export interface OverlayCallbacks {
  onReplay(): void;
  onExport(): void;
  onClose(): void;
}

export interface Overlay {
  el: HTMLElement;
  show(info: { timeMs: number; moves: number; best: boolean }): void;
  hide(): void;
}

/** 完成弹层：展示用时 / 步数 / 是否破纪录，提供“再来一局”与“导出图片”。 */
export function createOverlay(cb: OverlayCallbacks): Overlay {
  const el = document.createElement('div');
  el.className = 'pintu-overlay';
  el.hidden = true;
  el.innerHTML = `
    <div class="pintu-card" role="dialog" aria-modal="true" aria-live="polite">
      <button type="button" class="pintu-close" data-close aria-label="关闭">×</button>
      <h2>🎉 完成！</h2>
      <div class="sub">你拼完了这幅图</div>
      <div class="nums">
        <div><b data-time>00:00</b><span>用时</span></div>
        <div><b data-moves>0</b><span>步数</span></div>
      </div>
      <div class="best" data-best hidden>🏆 新纪录！</div>
      <div class="pintu-actions">
        <button type="button" data-export>导出图片</button>
        <button type="button" data-replay>再来一局</button>
      </div>
    </div>
  `;
  const replay = el.querySelector<HTMLButtonElement>('[data-replay]')!;
  const exportBtn = el.querySelector<HTMLButtonElement>('[data-export]')!;
  const closeBtn = el.querySelector<HTMLButtonElement>('[data-close]')!;
  replay.addEventListener('click', () => {
    el.hidden = true;
    cb.onReplay();
  });
  exportBtn.addEventListener('click', () => cb.onExport());
  closeBtn.addEventListener('click', () => cb.onClose());

  return {
    el,
    show(info) {
      el.querySelector<HTMLElement>('[data-time]')!.textContent = formatTime(info.timeMs);
      el.querySelector<HTMLElement>('[data-moves]')!.textContent = String(info.moves);
      const best = el.querySelector<HTMLElement>('[data-best]')!;
      best.hidden = !info.best;
      el.hidden = false;
    },
    hide() {
      el.hidden = true;
    },
  };
}
